import Image from "next/image";
import React from "react";
import CompareDroner from "./CompareDroner";
import CompareRowLayout from "./CompareRowLayout";
import DronerDesktopReference from "@components/Compare/DronerDesktopReference";

const CompareDesktop = ({
  dronersToCompare,
  droners,
  compareHelperItems,
  setCompareItems,
  removeCompareUrlParameter,
  compareItems,
}: {
  dronersToCompare: any;
  droners: string[];
  compareHelperItems: any;
  setCompareItems: any;
  removeCompareUrlParameter: any;
  compareItems: string[];
}) => {
  return (
    <div className="compare__desktop">
      {/* DRONERS */}
      <div>
        <CompareRowLayout
          headerText="Work area informations"
          compareHelperItems={compareHelperItems.workAreaInfo}
          dronersToCompare={dronersToCompare}
          rowOne={true}
          style={{
            borderRadius: droners.length === 0 ? "10px" : "10px 10px 0px 0px",
          }}
        >
          {dronersToCompare?.map((droner: any, i: number) => (
            <CompareDroner {...droner} key={i} />
          ))}
        </CompareRowLayout>

        {dronersToCompare.length > 0 && (
          <>
            {/* DRONERS WORK AREA INFORMATIONS */}
            <CompareRowLayout
              headerText="Work area informations"
              compareHelperItems={compareHelperItems.workAreaInfo}
              dronersToCompare={dronersToCompare}
            >
              {dronersToCompare.map((droner: any, i: number) => (
                <div className="compare__row--item" key={i}>
                  <h5>{droner.address}</h5>
                  <h5>{droner.freeDist}km</h5>
                  <h5>{droner.maxRange}km</h5>
                </div>
              ))}
            </CompareRowLayout>

            {/* TECHNICAL INFORMATIONS */}
            <CompareRowLayout
              headerText="Technical informations"
              compareHelperItems={compareHelperItems.technicalInfo}
              dronersToCompare={dronersToCompare}
            >
              {dronersToCompare.map((droner: any, i: number) => (
                <div className="compare__row--item" key={i}>
                  {droner?.userCertificate ? (
                    <a
                      href={droner?.userCertificate}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image
                        src="/assets/pdf-icon.png"
                        width="32"
                        height="32"
                        alt=""
                      />
                    </a>
                  ) : (
                    <h5>-</h5>
                  )}
                  <h5>{droner.equipment[0] ?? "-"}</h5>
                  <h5>DJI TERRA ADVANCED</h5>
                </div>
              ))}
            </CompareRowLayout>

            {/* REFERENCES */}
            <CompareRowLayout
              headerText="References"
              compareHelperItems={compareHelperItems.reference}
              dronersToCompare={dronersToCompare}
            >
              {dronersToCompare.map((droner: any, i: number) => (
                <div className="compare__reference" key={i}>
                  <DronerDesktopReference droner={droner} />
                  <button
                    className="compare__remove"
                    onClick={() => {
                      setCompareItems(
                        compareItems.filter((i: string) => i !== droner.uid)
                      );
                      removeCompareUrlParameter(droner.uid);
                    }}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </CompareRowLayout>
          </>
        )}
      </div>
    </div>
  );
};

export default CompareDesktop;
